import { Controller } from '@hotwired/stimulus'
import { refreshCsrfToken } from '../utils/csrf'

// Native only. Preloaded tabs share the session cookie: any tab refreshing it
// invalidates the CSRF tokens embedded in the other, already-rendered pages —
// their next form POST 422s. Whenever the screen (re)appears, re-sync the page's
// tokens against the current session.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.refresh = this.refresh.bind(this)
    window.addEventListener('native:appeared', this.refresh)
  }

  disconnect() {
    window.removeEventListener('native:appeared', this.refresh)
  }

  refresh() {
    return refreshCsrfToken(this.urlValue)
  }
}
